/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { InlineSupportNavigationHandlers } from 'cio/components/inline-support';

export default class Navigation extends Component<InlineSupportNavigationHandlers> {}
